export enum WellnessProgramStatus {
    Pending,
    Ended,
    Active,
}

export const WellnessProgramStatusTranslation: Record<WellnessProgramStatus, string> = {
    [WellnessProgramStatus.Pending]: "wellnessProgram.statuses.pending",
    [WellnessProgramStatus.Ended]: "wellnessProgram.statuses.ended",
    [WellnessProgramStatus.Active]: "wellnessProgram.statuses.active",
};